import { ReactNode } from "react";
import { queryClient } from "../lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";

interface Props {
  children: ReactNode;
}

export function QueryProvider({ children }: Props) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
